export default "__VITE_ASSET__PG22dGLu__"